import React, { useEffect } from "react";
import GRID_LAYOUT from "../../components/layout/GridLayout.component";
import { IViewProps } from "../View.types";
import { Col } from "react-bootstrap";
import PROJECT_CARD from "../../components/card/ProjectCard/ProjectCard.component";
import { useGetProjectsQuery } from "../../state-management/hooks";
import { ProjectSummary } from "../../api/models";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { isNullOrUndefined } from "../../shared/utils/data.utils";
import { useSelector } from "react-redux";
import { RootState } from "../../state-management/root-reducer";
import { PAGINATION_PAGE_SIZE } from "../../components/page/pagination/Pagination.types";
import { useAppDispatch } from "../../state-management/store";
import { setTotalCount } from "../../state-management/slices/pagination/pagination.slice";
import { setIsFetching } from "../../state-management/slices/search/search.slice";
import NO_RESULTS from "../../components/page/NoResults.component";
import { useErrorHandling } from "../../shared/utils/errorHandling.utils";

const renderProjectCards = (projectCollection: Array<ProjectSummary>) => {
  return projectCollection.map((project: ProjectSummary) => {
    return (
      <Col key={`${project.projectId}`}>
        <PROJECT_CARD
          subscription={{
            data: null,
            isLoading: false,
            error: null,
            isError: false,
          }}
          project={project}
        />
      </Col>
    );
  });
};

const PROJECTS_VIEW: React.FC<IViewProps> = () => {
  const dispatch = useAppDispatch();

  // App State
  const { offset } = useSelector((state: RootState) => state.pagination);
  const { searchTerm } = useSelector((state: RootState) => state.search);

  const { data, error, isLoading, isError, isFetching } = useGetProjectsQuery({
    offset: offset,
    limit: PAGINATION_PAGE_SIZE,
    search: searchTerm ? searchTerm : undefined,
  });

  useErrorHandling(isError, error);
  useEffect(() => {
    dispatch(setIsFetching(isFetching));

    if (
      !isNullOrUndefined(data) &&
      !isNullOrUndefined(data.total) &&
      data.total >= 0
    ) {
      dispatch(setTotalCount(data.total));
    }
  }, [data, dispatch, isFetching]);

  return (
    <GRID_LAYOUT isLoading={isLoading} isFetching={isFetching}>
      {(isLoading || isFetching) && (
        <Col className="no-results-column">
          <FontAwesomeIcon
            icon={faSpinner}
            className="fa-spin"
            size="3x"
            color="#666666"
          />
        </Col>
      )}
      {isError && (
        <Col className="no-results-column">
          <div>{JSON.stringify(error)}</div>
        </Col>
      )}
      {!isNullOrUndefined(data) &&
        !isNullOrUndefined(data.results) &&
        !isLoading &&
        !isFetching &&
        data.results.length === 0 && (
          <Col className="no-results-column">
            <NO_RESULTS isSearch={!isNullOrUndefined(searchTerm)} />
          </Col>
        )}
      {!isNullOrUndefined(data) &&
        !isNullOrUndefined(data.results) &&
        !isLoading &&
        !isFetching &&
        renderProjectCards(data.results)}
    </GRID_LAYOUT>
  );
};

export default PROJECTS_VIEW;
